import classNames from "classnames";
// eslint-disable-next-line no-restricted-imports -- TODO: update to `next/navigation` before using this component in App Router
import { useRouter } from "next/router";
import { ParsedQs, stringify } from "qs";

import parseNextRouterAsPath from "@/utils/parseNextRouterAsPath";

import Checkbox from "@/components/botanic/Checkbox";

// TODO This can likely be DRY'd up with the config also defined here:
// TODO components/UnifiedShop/MobileFilterModalAndShortcutsUI/MobileFilterModalAndShortcutsUI.tsx:23
export const FULFILLMENT_METHODS = [
  { name: "Pickup", value: "pickup" },
  { name: "Delivery", value: "delivery" },
  { name: "Direct Shipping", value: "shipping" },
];
export const FULFILLMENT_LABEL_MAP = FULFILLMENT_METHODS.reduce<
  Record<string, string>
>((labelMap, { name, value }) => ({ ...labelMap, [value]: name }), {});

const FulfillmentFilters = ({
  sectionPadding,
}: {
  sectionPadding?: string;
}) => {
  const { asPath } = useRouter();
  const { path, query } = parseNextRouterAsPath<ParsedQs>(asPath);
  const selectedFulfillment = Array.isArray(query.fulfillment)
    ? (query.fulfillment as string[])
    : [];
  const { page: _page, ...otherParams } = query;

  return (
    <div
      className={classNames(
        "py-md md:border-t border-light-grey",
        sectionPadding,
      )}
    >
      {FULFILLMENT_METHODS.map((fulfillment) => (
        <Checkbox
          id={fulfillment.value}
          key={fulfillment.value}
          disabled={false}
          data-testid={`_${fulfillment.value}`}
          href={{
            pathname: path,
            query: stringify(
              {
                ...otherParams,
                fulfillment: selectedFulfillment.includes(fulfillment.value)
                  ? selectedFulfillment.filter((f) => f !== fulfillment.value)
                  : [...selectedFulfillment, fulfillment.value],
              },
              { arrayFormat: "brackets", indices: false },
            ),
          }}
          checked={
            Array.isArray(selectedFulfillment) &&
            (selectedFulfillment as string[]).includes(fulfillment.value)
          }
          className="p-xs"
          value={fulfillment.value}
        >
          {fulfillment.name}
        </Checkbox>
      ))}
    </div>
  );
};

export default FulfillmentFilters;
